/// <amd-module name="TFS/DRITools/util/RequestNode" />
import { IGroup } from "OfficeFabric/DetailsList";

export interface RequestNode {
    ActivityLog: Obj;
    IisLog: Obj;
    ProductTrace: Obj[];
    children: RequestNode[];
    parentId: string;
    depth: number;
    hasSlowCommandTrace?: boolean;
    productTraceGroups?: IGroup[];
    trace?: JSX.Element[];
}

export interface Obj {
    [key: string]: any;
}
